import React from "react";
import backgroundimg from "./../image/banner.png";
import { Helmet } from "react-helmet";
import { BrainCircuit, LineChart } from "lucide-react";

const ProductScreen = ({ title }) => {
  const isconsultant = title === "Consulting with Nexify Clients";
  return (
    <div className="w-full h-auto bg-white flex flex-col items-center justify-center lg:mt-20 mt-0">
      <Helmet>
        <title>Cosulting - Nexify Infosystms</title>
        <meta name="description" content="Explore consulting services provided by Nexify, including IT strategy, technology consulting, and more." />
        <meta name="keywords" content="Consulting, IT Strategy, Technology Consulting, Nexify, Business Growth, Digital Transformation" />
      </Helmet>
      {/* Header Section */}
      <div
        className="w-full h-[440px] bg-cover bg-center relative flex items-center justify-center"
        style={{ backgroundImage: `url(${backgroundimg})` }}
      >
        <div className="relative z-0 flex justify-center lg:justify-start items-center w-full px-4 sm:px-10 lg:px-20">
          <div
            className="opacity-0 translate-y-10 animate-slideUp bg-[#0e55a8] p-6 shadow-lg text-white inline-block text-center lg:text-left max-w-[90%] sm:max-w-[80%] md:max-w-[60%] lg:max-w-[60%] lg:ml-14 border border-white/20 rounded-lg relative"
            style={{
              animation: "slideUp 1s ease-in-out forwards",
              animationDelay: "2s",
            }}
          >
            {/* 🔵 Dot Pattern Overlay Inside Box */}
            <div className="absolute inset-0 bg-[radial-gradient(circle,_rgba(255,255,255,0.2)_1px,_transparent_1px)] bg-[size:6px_6px] opacity-50 pointer-events-none rounded-lg"></div>

            <h1 className="text-[8vw] md:text-[66px]  font-semibold mb-2 whitespace-nowrap">
              Nexify Consulting
            </h1>
            <h2 className="text-[5vw] md:text-[40px] text-[#efefef]">
              Where Consulting Meets Excellence
            </h2>
          </div>
        </div>

      </div>


      <div className="w-full max-w-[1320px] px-4 mx-auto mt-5 mb-5">

        <div className="flex flex-col gap-6">
          <div className="bg-white flex flex-col md:flex-row items-center p-6 ">
            <div className="flex items-center justify-center w-16 h-16 bg-[#cce5ff] rounded-full mr-6">
              <LineChart className="text-[#005eb8] text-8xl" />
            </div>
            <div className="flex-1">
              <h3 className="lg:text-[30px] text-[25px] leading-[1.25] text-[#363638] font-[700] mb-2">IT Strategy Consulting</h3>
              <p className="text-[#6d6d70] font-[400] text-[16px] leading-[1.8]">
                Our IT consultants collaborate with your team to assess your infrastructure, identify improvements, and develop scalable strategies. We offer technology road mapping, resource optimization, risk assessment, and cost-effective implementation plans. Our goal is to enhance efficiency, improve customer experiences, and drive digital transformation for long-term growth.
              </p>
            </div>
          </div>
          <div className="bg-white flex flex-col md:flex-row items-center p-6 ">
            <div className="flex items-center justify-center w-16 h-16 bg-[#cce5ff] rounded-full mr-6">
              <BrainCircuit className="text-[#005eb8] text-8xl" />
            </div>
            <div className="flex-1">
              <h3 className="lg:text-[30px] text-[25px] leading-[1.25] text-[#363638] font-[700] mb-2">Technology Consulting</h3>
              <p className="text-[#6d6d70] font-[400] text-[18px] leading-[1.8]">
              We provide technology consulting to optimize your IT infrastructure, enhance efficiency, and drive growth. Our tailored solutions include cloud adoption, software upgrades, AI integration, and custom app development, ensuring seamless implementation and ongoing support.
              </p>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
};

export default ProductScreen;